var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-toast',{attrs:{"visible":true,"title":_vm.$t('toast_admin_message'),"no-auto-hide":"","toaster":_vm.toaster}},[_c('div',{staticClass:"body-wrapper"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }